import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { CircleCheck } from "lucide-react";
import { useState } from "react";

export default function FormResetPassword(props: {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}) {
  const t = useScopedI18n("找回密码");

  const [isShow, setShow] = useState(false);

  return (
    <div className="relative w-full">
      <input
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
        type="password"
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        className="h-10 w-full rounded border-b border-[#F0F0F0] text-sm outline-none placeholder:text-[#A6A6A6] hover:border-[#FF5100] focus:border-[#FF5100] md:border md:border-[#C2C6CE] md:px-4 md:placeholder:text-[#E5E5E5]"
      />

      {isShow && (
        <div className="absolute left-0 right-0 z-20 h-42 w-full rounded-sm border border-[#E5E5E5] bg-white px-3 py-3 shadow-xl md:px-4">
          <div className="border-b border-[#BABABA]">
            <h3 className="mb-2 text-base font-medium text-[#424242]">
              {t("密码应满足以下要求：")}
            </h3>

            <p className="mb-1 text-xs text-[#424242]">
              {t("不能和历史2次密码相同或相似")}
            </p>

            <p className="mb-3 text-xs text-[#424242]">
              {t("不能包含用户名、手机号、邮箱前缀的正倒序")}
            </p>
          </div>
          <div className="space-y-2 pt-3 text-xs text-[#383838]">
            <div className="flex items-center space-x-1">
              <div
                className={cn("text-[#C2C6CE]", {
                  "text-[#48C16D]":
                    props.value?.length &&
                    props.value?.length >= 8 &&
                    props.value?.length <= 60,
                })}>
                <CircleCheck size={14} />
              </div>

              <span>{t("密码长度限制")}</span>
            </div>
            <div className="flex space-x-1">
              <div
                className={cn("text-[#C2C6CE]", {
                  "text-[#48C16D]":
                    props.value &&
                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,60}$/.test(
                      props.value || ""
                    ),
                })}>
                <CircleCheck size={14} />
              </div>

              <span>{t("密码格式限制")}</span>
            </div>
            {/* <div className="flex items-center space-x-1">
              <div
                className={cn("text-[#C2C6CE]", {
                  "text-[#48C16D]":
                    props.value && !/(.)\1{2,}/.test(props.value || ""),
                })}>
                <CircleCheck size={14} />
              </div>

              <span>{t("密码不能包含3个及以上连续相同的字符")}</span>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}
